import { useEffect, useMemo, useState } from "react";
import type { CourseApi } from "../../../lib/api/courseApi";
import { readStageModels, stageModelUrlFor } from "../lib/stage";
import type { StageModelEntry } from "../lib/stage";

/**
 * 운영자가 올린 3D 모델(카탈로그 stage_model · 활성만) — 목록과 렌더러 stageModelUrl(키 → GLB blob URL).
 * 2026-10-11: 자유 놀이터 교사 꾸밈(배치 도구 인벤토리 · 학생 · 칠판 룸 화면)이 같이 쓴다. 못 읽으면 빈 목록 · url 없음.
 */
export function useStageModels(courseApi: CourseApi | null): {
  models: ReadonlyMap<string, StageModelEntry>;
  url: ((key: string) => Promise<string | null>) | null;
} {
  const [models, setModels] = useState<ReadonlyMap<string, StageModelEntry>>(new Map());
  useEffect(() => {
    if (!courseApi) return;
    let alive = true;
    courseApi
      .catalog("stage_model")
      .then((v) => alive && setModels(readStageModels(v)))
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, [courseApi]);
  const url = useMemo(
    () =>
      courseApi && models.size
        ? stageModelUrlFor(models, (sha) => courseApi.stageModel(sha))
        : null,
    [courseApi, models],
  );
  return { models, url };
}
